import DateInput from './DateInput.jsx';

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/DateInput/index.js